import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { RefreshCcw } from 'lucide-react';

export function PanelHeader({ title, subtitle, onRefresh, right }) {
  return (
    <div className="flex items-start justify-between">
      <div>
        <h2 className="text-[18px] font-semibold">{title}</h2>
        {subtitle && <p className="mt-1 text-[11.5px] text-muted-foreground max-w-2xl">{subtitle}</p>}
      </div>
      {right ? right :
        (onRefresh && <Button variant="ghost" size="sm" onClick={onRefresh} className="gap-1.5"><RefreshCcw className="h-3.5 w-3.5" /> Refresh</Button>)
      }
    </div>
  );
}

export function Field({ label, children, className }) {
  return (
    <div className={className}>
      <Label className="text-[11px]">{label}</Label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export function summarize(d) {
  if (!d || typeof d !== 'object') return '';
  return d.name || d.title || d.text?.slice?.(0, 60) || d.from || d.id || '(document)';
}
